import { Permissions, useScopeChecker } from 'src/rbac';

export type PatientDetailsGates = {
  /** may activate an inactive patient */
  canActivatePatient: boolean;
  /** may deactivate an active patient */
  canDeactivatePatient: boolean;
  /** may see the patient MDS-assessments tab */
  canAccessMdsTab: boolean;
};

/**
 * Permission gates for the patient-details header actions + MDS tab (Segment B migration).
 *
 * Migrated from the legacy `permissionData.includes('<Display Name>')` display-name check to
 * the instrumented scopeKey path (`useScopeChecker()` + `Permissions.*`). The scopeKey display
 * names match the old paths.ts strings (parity-verified), so behavior is preserved; these
 * checks now emit RUM telemetry.
 */
export function usePatientDetailsGates(): PatientDetailsGates {
  const has = useScopeChecker();
  return {
    canActivatePatient: has(Permissions.ACTIVATE_PATIENT),
    canDeactivatePatient: has(Permissions.DEACTIVATE_PATIENT),
    canAccessMdsTab: has(Permissions.ACCESS_TO_PATIENT_MDS_TAB),
  };
}
